"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSIGError = exports.ErrorCodesPipelineSignTransaction = void 0;
const error_1 = require("../../../../stellar-plus/error");
const transaction_1 = require("../../../../stellar-plus/error/helpers/transaction");
var ErrorCodesPipelineSignTransaction;
(function (ErrorCodesPipelineSignTransaction) {
    // PSIG0 General
    ErrorCodesPipelineSignTransaction["PSIG001"] = "PSIG001";
    ErrorCodesPipelineSignTransaction["PSIG002"] = "PSIG002";
    ErrorCodesPipelineSignTransaction["PSIG003"] = "PSIG003";
    ErrorCodesPipelineSignTransaction["PSIG004"] = "PSIG004";
})(ErrorCodesPipelineSignTransaction || (exports.ErrorCodesPipelineSignTransaction = ErrorCodesPipelineSignTransaction = {}));
const noRequirementsProvided = (conveyorBeltErrorMeta, transaction) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineSignTransaction.PSIG001,
        message: 'No signature requirements provided!',
        source: 'PipelineSignTransaction',
        details: `No signature requirements provided for the transaction. It is possible to use the classicSignRequirements pipeline to automatically identify Stellar Classic signature requirements for a given transaction.`,
        meta: {
            transactionData: (0, transaction_1.extractTransactionData)(transaction),
            conveyorBeltErrorMeta,
        },
    });
};
const noSignersProvided = (conveyorBeltErrorMeta, transaction) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineSignTransaction.PSIG002,
        message: 'No signers provided!',
        source: 'PipelineSignTransaction',
        details: `No signers provided. Review your transaction workflow to ensure the proper signers are being provided for the transaction.`,
        meta: {
            transactionData: (0, transaction_1.extractTransactionData)(transaction),
            conveyorBeltErrorMeta,
        },
    });
};
const signerNotFound = (conveyorBeltErrorMeta, transaction, missingSigner, signers) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineSignTransaction.PSIG003,
        message: 'The signer was not found!',
        source: 'PipelineSignTransaction',
        details: `The required signer was not found in the provided signers list. The missing signer is: ${missingSigner}. `,
        meta: {
            data: {
                signers,
            },
            transactionData: (0, transaction_1.extractTransactionData)(transaction),
            conveyorBeltErrorMeta,
        },
    });
};
const couldntSignTransaction = (error, conveyorBeltErrorMeta, transaction, signerPublicKey) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineSignTransaction.PSIG004,
        message: 'Failed to sign transaction!',
        source: 'PipelineSignTransaction',
        details: `An issue occurred while signing the transaction with the signer: ${signerPublicKey}.`,
        meta: {
            error,
            transactionData: (0, transaction_1.extractTransactionData)(transaction),
            conveyorBeltErrorMeta,
        },
    });
};
exports.PSIGError = {
    noRequirementsProvided,
    noSignersProvided,
    signerNotFound,
    couldntSignTransaction,
};
